import { ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-calendar-header',
  templateUrl: './calendar-header.component.html',
  styleUrls: ['./calendar-header.component.scss'],
  imports: [MatIconModule, MatButtonModule],
  standalone: true,
})
export class CalendarHeaderComponent<D> implements OnDestroy {
  private readonly calendar = inject<MatCalendar<D>>(MatCalendar);
  private readonly dateAdapter = inject<DateAdapter<D>>(DateAdapter);
  private readonly dateFormats = inject<MatDateFormats>(MAT_DATE_FORMATS);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroy$ = new Subject<void>();

  constructor() {
    this.calendar.stateChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMonthName(month: string): string {
    let monthLabel: string = month;

    switch (month) {
      case 'JAN':
        monthLabel = 'Enero';
        break;
      case 'FEB':
        monthLabel = 'Febrero';
        break;
      case 'MAR':
        monthLabel = 'Marzo';
        break;
      case 'APR':
        monthLabel = 'Abril';
        break;
      case 'MAY':
        monthLabel = 'Mayo';
        break;
      case 'JUN':
        monthLabel = 'Junio';
        break;
      case 'JUL':
        monthLabel = 'Julio';
        break;
      case 'AUG':
        monthLabel = 'Agosto';
        break;
      case 'SEP':
        monthLabel = 'Septiembre';
        break;
      case 'OCT':
        monthLabel = 'Octubre';
        break;
      case 'NOV':
        monthLabel = 'Noviembre';
        break;
      case 'DEC':
        monthLabel = 'Diciembre';
        break;
    }

    return monthLabel;
  }

  private getMonthAbbrev(month: string): string {
    const full = this.getMonthName(month);
    return full.slice(0, 3).toUpperCase();
  }

  periodLabel(): string {
    const date = this.dateAdapter
      .format(this.calendar.activeDate, this.dateFormats.display.monthYearLabel)
      .toLocaleUpperCase();

    const dateSplit = date.split(' ');
    if (dateSplit.length >= 2) {
      return this.getMonthAbbrev(dateSplit[0]) + ' ' + dateSplit[1];
    }

    return date;
  }

  previousClicked(mode: 'month' | 'year'): void {
    this.calendar.activeDate = mode === 'month'
      ? this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1)
      : this.dateAdapter.addCalendarYears(this.calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year'): void {
    this.calendar.activeDate = mode === 'month'
      ? this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1)
      : this.dateAdapter.addCalendarYears(this.calendar.activeDate, 1);
  }
}
